import $ from "jquery"

class Filter {
	constructor() {
		this.postsFilter();

		this.videoFilter();
		this.noResulstsMsg = $(".filter-container .hx-noresults").val();
		this.filterTitle = $(".filter-container .hx-filtertitle").val();

		this.filterContainer = $(".filter-container");
		this.gridContainer = $(".grid-container");
		this.videoLoader = $(".filter-container .lds-loader");
		this.clearFilterBtn = $(".filter-bar .filter--clear");

		//this.fetchVideos();
	}

	postsFilter() {
		if ($('.posts-filter').length) {

			var itemSelector = '.grid-item';

			var jQueryBridget = require('jquery-bridget');
			var Isotope = require('isotope-layout');

			jQueryBridget('isotope', Isotope, $);

			var $container = $('.filter-grid').isotope({
				itemSelector: itemSelector,
				layoutMode: 'fitRows'
			});

			$('.categories li').on('click', 'button', function () {
				$('.categories li').removeClass('selected');
				$(this).addClass('selected');

				var filterValue = $(this).attr('data-filter');
				$container.isotope({ filter: filterValue });
			});
		}
	}

	videoFilter() {
		var self = this;

		if ($('.video-module .filter-bar').length) {
			$('.filter-bar .dropdown-toggle').on('click', function (event) {
				if ($(this).parent().hasClass('show')) {
					$(this).parent().removeClass('show');
					$(this).parent().find('.dropdown-menu').removeClass('show');
				} else {
					$('.filter-bar .button-group, .filter-bar .dropdown-menu').removeClass('show');

					$(this).parent().addClass('show');
					$(this).parent().find('.dropdown-menu').addClass('show');
				}
			});

			$('.filter-bar .button-group .clear').on('click', function (event) {
				$(this).parent().closest('.dropdown-menu').find('input[type="checkbox"]').prop('checked', false);
			});

			$('.filter-bar .dropdown-menu .close').on('click', function (event) {
				$('.filter-bar .button-group, .filter-bar .dropdown-menu').removeClass('show');
			});

			$('.filter-bar .dropdown-settings .save').on('click', function (event) {
				$('.filter-bar .button-group, .filter-bar .dropdown-menu').removeClass('show');
				self.filterVideos();
			});

			$('.filter-bar .filter--clear').on('click', function (event) {
				$('.filter-bar input[type="checkbox"]').prop('checked', false);
				$(this).fadeOut();
				self.filterVideos();
			});
		}
	}

	filterVideos() {
		var self = this;

		let postVars = {
			action: 'hx_get_videos',
			//ssid: new Date().getTime(),
			nonce: ajax.nonce,
			'dates': $(".filter--date input:checkbox:checked").map(function () {
				return $(this).val();
			}).get(),
			'categories': $(".filter--categories input:checkbox:checked").map(function () {
				return $(this).val();
			}).get(),
			'categories_nicename': $(".filter--categories input:checkbox:checked").map(function () {
				return $(this).parent().find('label span').text()
			}).get()
		};

		if (!postVars.dates.length && !postVars.categories.length) {
			self.gridContainer.fadeIn();
			self.filterContainer.fadeOut();
			self.clearFilterBtn.fadeOut();
			return false;
		} else {
			self.clearFilterBtn.fadeIn();
			self.filterContainer.fadeIn();
			self.gridContainer.fadeOut();
			self.videoLoader.fadeIn();
		}


		if (self.filterContainer.data('requestRunning')) {
			return;
		}

		self.filterContainer.data('requestRunning', true).find('.results').html('');

		// Initialize loading animation
		// TODO:

		$.ajax({
			beforeSend: xhr => {
				xhr.setRequestHeader('X-WP-Nonce', ajax.nonce)
			},
			url: ajax.url,
			method: 'GET',
			data: postVars,
			dataType: 'json',
		}).done(response => {
			var html = '';

			if (response.video_html) {
				html = '<div class="col-12"><h2 class="filter-title text-left font-weight-normal mt-5 mb-4">' + self.filterTitle + ': <span>' + postVars.categories_nicename.join(', ') + '</span></h2></div>';

				$.each(response.video_html, function (key, data) {
					html += '<div class="col-12 col-sm-4">' + data + '</div>';
				});
			} else {
				html = '<h3 class="text-center w-100 op--4 font-weight-normal my-5">' + self.noResulstsMsg + '</h3>';
			}

			self.filterContainer.data('requestRunning', false).fadeIn().find('.results').html(html);
			self.videoLoader.fadeOut();
		});
	}
}


export default Filter;
